export interface SourceFile {
  id: number;
  file_name: string;
  file_type?: string;
  date_created?: string;
  created_by?: string;
}

export interface SourceStats {
  versions: number;
  rows: number | null;
  lastUpdated: string | null;
}

export type SortKey = 'recent' | 'oldest' | 'nameAsc' | 'nameDesc';

export const ALL_TYPES = 'all';

export const getTypeLabel = (source: SourceFile): string => {
  const raw = `${source.file_type || ''}`.toLowerCase();
  const name = `${source.file_name || ''}`.toLowerCase();
  if (raw.includes('parquet') || name.endsWith('.parquet')) return 'PARQUET';
  if (raw.includes('xls') || raw.includes('spreadsheet') || name.endsWith('.xlsx')) return 'XLSX';
  if (raw.includes('txt') || raw.includes('plain') || name.endsWith('.txt')) return 'TXT';
  return 'CSV';
};

export const formatRowCount = (rows: number | null | undefined): string => {
  if (rows === null || rows === undefined) return '—';
  if (rows >= 1_000_000) return `${(rows / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  if (rows >= 1000) return `${(rows / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  return `${rows}`;
};

const DAY_MS = 24 * 60 * 60 * 1000;

export const formatLastUpdated = (isoDate: string | null | undefined): string => {
  if (!isoDate) return '—';
  const date = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(date.getTime())) return isoDate;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffDays = Math.round((today.getTime() - date.getTime()) / DAY_MS);
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const isRecent = (isoDate: string | null | undefined): boolean => {
  if (!isoDate) return false;
  const date = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(date.getTime())) return false;
  return Date.now() - date.getTime() < 2 * DAY_MS;
};

export const pluralise = (count: number, word: string): string =>
  `${count} ${word}${count === 1 ? '' : 's'}`;

export const formatCreatedOn = (isoDate: string | null | undefined): string => {
  if (!isoDate) return '—';
  const date = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(date.getTime())) return isoDate;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};
